import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pan-floating-label',
  templateUrl: './pan-floating-label.component.html',
  styleUrl: './pan-floating-label.component.scss',
  standalone: false,
})
export class PanFloatingLabelComponent {
  public label = input<string>('');
  public for = input<string>('');
  public required = input<boolean>(false);
}
